function TimestampToDateFormatFilter() {
    const pad = (number) => {
        return number > 9 ? '' + number : '0' + number;
    };
    return (input) => {
        const date = new Date(input * 1000);
        const year = pad(date.getFullYear());
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        return `${day}.${month}.${year}`;
    };
}

export default TimestampToDateFormatFilter;



// WEBPACK FOOTER //
// ./src/app/filters/timestampToDateFromat.js